import { IconButton } from '@mui/material';
import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const CloseDialogButton = ({ handleClose, ...props }) => {
	return (
		<IconButton aria-label='Close' {...props} onClick={handleClose}>
			<ChevronRightIcon />
		</IconButton>
	);
};

export default CloseDialogButton;
